// 対象(value)ごとの data列 表示名定義
export const DATA_LABEL_MAP = {
  sponsor_vision: {
    data1: 'Style-H',
    data2: 'まついハートクリニック',
    data3: 'アパマンショップ 岩槻店/岩槻お客様サロン',
    data4: 'マナマリエ歯科診療所',
    data5: 'セオサイクル 岩槻店',
    data6: '永島医院',
    data7: '株式会社フルオール',
    data8: '丸山記念総合病院',
    data9: '株式会社岩槻タクシー',
    data10: '株式会社翔栄',
    data11: '漢方田中薬局',
    data12: '岩槻若葉幼稚園',
    data13: '岩槻西原クリニック',
    data14: '吉武歯科医院',
    data15: '万代書店 岩槻店/クレーンゲーム倉庫 岩槻店',
    data16: 'いわつき自動車学校',
    data17: '岩槻人形博物館',
    data18: 'にぎわい交流館岩槻',
    data19: 'さいたま観光国際協会',
    data20: '岩槻人形協同組合',
    data21: '岩槻城と城下町',
    data22: '空データ',
    data23: '空データ',
    data24: '空データ',
    data25: '空データ'

  },

  sponsor_map: {
    data1: 'Style-H',
    data2: 'まついハートクリニック',
    data3: 'アパマンショップ 岩槻店/岩槻お客様サロン',
    data4: 'マナマリエ歯科診療所',
    data5: 'セオサイクル 岩槻店',
    data6: '永島医院',
    data7: '株式会社フルオール',
    data8: '丸山記念総合病院',
    data9: '株式会社岩槻タクシー',
    data10: '株式会社翔栄',
    data11: '漢方田中薬局',
    data12: '岩槻若葉幼稚園',
    data13: '岩槻西原クリニック',
    data14: '吉武歯科医院',
    data15: '万代書店 岩槻店/クレーンゲーム倉庫 岩槻店',
    data16: 'いわつき自動車学校',
    data17: '岩槻人形博物館',
    data18: 'にぎわい交流館岩槻',
    data19: 'さいたま観光国際協会',
    data20: '岩槻人形協同組合',
    data21: '岩槻城と城下町',
    data22: '空データ',
    data23: '空データ',
    data24: '空データ',
    data25: '空データ'
  },

  facility_name: {
    data1: '愛宕神社・岩槻城大構',
    data2: '一里塚跡・日光御成道',
    data3: '岩槻郷土資料館',
    data4: '岩槻城址公園（岩槻城跡）',
    data5: '岩槻人形博物館',
    data6: '岩槻藩遷喬館',
    data7: '願生寺',
    data8: '淨安寺',
    data9: '浄源寺',
    data10: '浄国寺',
    data11: '真福寺貝塚',
    data12: '住吉神社',
    data13: '諏訪神社（太田）',
    data14: '大龍寺',
    data15: '丹過庚申堂',
    data16: '知楽院',
    data17: '東玉大正館',
    data18: '時の鐘',
    data19: 'にぎわい交流館いわつき',
    data20: '梅照院',
    data21: '久伊豆神社（宮町）',
    data22: '冨士浅間神社',
    data23: '芳林寺',
    data24: '彌勒密寺（岩槻大師）',
    data25: '八雲神社',
    data26: '龍門寺',
    data27: '岩槻小学校のイチョウ',
    data28: '八幡神社（南辻）',
    data29: '渋江鋳金遺跡',
    data30: 'あさつゆの里',
    data31: '岩槻文化公園',
    data32: '鶴姫神社',
    data33: '元浅間神社',
    data34: 'さいたまスイーツ（岩槻）',
    data35: '伝統産業（岩槻の人形）',
    data36: '伝統産業（岩槻の料亭、和菓子等）',
    data37: '伝統産業（見学・体験）'
  },

  facility_category: {
    data1: '愛宕神社・岩槻城大構',
    data2: '一里塚跡・日光御成道',
    data3: '岩槻郷土資料館',
    data4: '岩槻城址公園（岩槻城跡）',
    data5: '岩槻人形博物館',
    data6: '岩槻藩遷喬館',
    data7: '願生寺',
    data8: '淨安寺',
    data9: '浄源寺',
    data10: '浄国寺',
    data11: '真福寺貝塚',
    data12: '住吉神社',
    data13: '諏訪神社（太田）',
    data14: '大龍寺',
    data15: '丹過庚申堂',
    data16: '知楽院',
    data17: '東玉大正館',
    data18: '時の鐘',
    data19: 'にぎわい交流館いわつき',
    data20: '梅照院',
    data21: '久伊豆神社（宮町）',
    data22: '冨士浅間神社',
    data23: '芳林寺',
    data24: '彌勒密寺（岩槻大師）',
    data25: '八雲神社',
    data26: '龍門寺',
    data27: '岩槻小学校のイチョウ',
    data28: '八幡神社（南辻）',
    data29: '渋江鋳金遺跡',
    data30: 'あさつゆの里',
    data31: '岩槻文化公園',
    data32: '鶴姫神社',
    data33: '元浅間神社',
    data34: 'さいたまスイーツ（岩槻）',
    data35: '伝統産業（岩槻の人形）',
    data36: '伝統産業（岩槻の料亭、和菓子等）',
    data37: '伝統産業（見学・体験）'
  },

  langage: {
    data1: '日本語',
    data2: '英語',
    data3: '中国語',
    data4: '韓国語'
  },

  illustration: {
    data1: '愛宕神社・岩槻城大構',
    data2: '岩槻郷土資料館',
    data3: '岩槻城址公園（岩槻城跡）',
    data4: '岩槻人形博物館',
    data5: '岩槻藩遷喬館',
    data6: '岩槻駅',
    data7: 'あさつゆの里',
    data8: '淨安寺',
    data9: '浄国寺',
    data10: '諏訪神社（太田）',
    data11: '大龍寺',
    data12: '東玉大正館',
    data13: '時の鐘',
    data14: 'にぎわい交流館いわつき',
    data15: '久伊豆神社（宮町）',
    data16: '冨士浅間神社',
    data17: '芳林寺',
    data18: '彌勒密寺（岩槻大師）',
    data19: '八雲神社',
    data20: '龍門寺',
    data21: '鶴姫神社',
    data22: '知楽院',
    data23: '元浅間神社',
    data24: '東武アーバンパークライン',
    data25: '東武バス',
    data26: '国際興業バス',
    data27: '朝日バス',
    data28: 'さいたま市コミュニティバス',
    data29: '車_青',
    data30: '車_赤',
    data31: '車_橙',
    data32: 'バイク',
    data33: 'レンタルサイクルA',
    data34: 'レンタサイクルB',
    data35: '歩く人',
    data36: '雲1',
    data37: '雲2',
    data38: '雲3',
    data39: '馬に乗った武士',
    data40: '真福寺貝塚',
    data41: '渋江鋳金遺跡',
    data42: 'ここからGO',
    data43: 'オオタカ上',
    data44: 'オオタカ下',
    data45: 'navigation'
  },

  top: {
    data1: 'HOME',
    data2: 'ルート＆マップ',
    data3: 'バスのりば',
    data4: 'レンタルサイクル',
    data5: 'イベント情報',
    data6: '施設名から探す',
    data7: '見る',
    data8: '体験する',
    data9: '買う・食べる',
    
  }
}